import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import constant from '../../constants.json';

const Footer = () => {
    const [contact, setContact] = useState({
        email: '',
        subject: 'StaticForms - Contact Form',
        honeypot: '', // if any value received in this field, form submission will be ignored.
        message: '',
        accessKey: 'f6439803-bc4d-4407-ac5b-a6d109979abe' // get your access key from https://www.staticforms.xyz
    });

    const handleChange = e => setContact({ ...contact, [e.target.name]: e.target.value });

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            const res = await fetch('https://api.staticforms.xyz/submit', {
                method: 'POST',
                body: JSON.stringify(contact),
                headers: { 'Content-Type': 'application/json' }
            });

            const json = await res.json();
            console.log(json)
            if (json.message.toLowerCase().includes("success")) {
                Swal.fire({
                  title: "Thank you for reaching out to us",
                  icon: "success"
                });
            } else {
                Swal.fire({
                  title: json.message,
                  icon: "error"
                });
            }
        } catch (e) {
            console.log('An error occurred', e);
            // setResponse({
            //     type: 'error',
            //     message: 'An error occured while submitting the form',
            //     icon: 'error'
            // });
            Swal.fire({
                  title: 'An error occured while submitting the form',
                  icon: "error"
                });
        }
    };

    return (
        <footer className="py-11 bg-primary position-relative" data-bg-img="../../assets/images/bg/03.png">
            <div className="shape-1" style={{ height: '150px', overflow: 'hidden' }}>
                <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '100%', width: '100%' }}>
                    <path d="M0.00,49.98 C150.00,150.00 271.49,-50.00 500.00,49.98 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: '#fff' }} />
                </svg>
            </div>
            <Container className=" mt-11">
                <Row>
                    <div className="col-12 col-lg-6 col-xl-6 mt-auto mb-auto">
                        <Row>
                            <Col className="col-12 col-sm-12 navbar-dark">
                                
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <Col className="col-12 col-sm-6">
                                <Link className="footer-logo text-white h1 mb-0" style={{ textDecoration: 'none' }} to="/">
                                    {constant.APP_NAME.substring(0,constant.APP_NAME.length/2)}<span className="font-weight-bold">{constant.APP_NAME.substring(constant.APP_NAME.length/2, constant.APP_NAME.length)}.</span>
                                </Link>
                            </Col>
                        </Row>
                    </div>
                    <div className="col-12 col-lg-6 col-xl-6 me-auto mb-6 mb-lg-0">
                        <div className="subscribe-form bg-warning-soft p-5 rounded">
                            <h5 className="mb-4 text-white">Reach Us</h5>
                            {/*<h6 className="text-light">Leave your email, we will contact you</h6>*/}

                            <form id="mc-form" className="group" action="https://api.staticforms.xyz/submit" method="post" onSubmit={handleSubmit}>
                                <input type="email" name="email" className="email form-control input" id="mc-email" placeholder="Email Address" required style={{ height: '50px' }} onChange={handleChange} required />
                                <input type="text" name="message" className="form-control input" id="mc-message" placeholder="Leave Your Question Here" required style={{ height: '100px', marginTop: 4 }} onChange={handleChange} required />
                                <input className="btn btn-outline-light btn-block mt-3 mb-2" type="submit" name="subscribe" defaultValue="Subscribe" />
                            </form>
                        </div>
                    </div>
                </Row>
                <Row className="text-white text-center">
                    <Col>
                        <hr/>Copyright 2025 - PT. Akar Tumbuh Buah | All Rights Reserved
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
